import createSimplePrivateGallery from '@PROJECT_ROOT/assets/desktop/js/search/simplePrivateGallery';
import { openUnitCard, closeOtherCardsInFacility } from '@PROJECT_ROOT/assets/desktop/js/search/UnitCard';
import { triggerGoogleAnalyticsSendEvent } from '@PROJECT_ROOT/assets/desktop/js/library/triggerGoogleAnalyticsSend';
import verticalSmoothScrollToPosition from '@PROJECT_ROOT/assets/desktop/js/library/verticalSmoothScrollToPosition';

const slideToggleTime = 100;

function unconfiguredFacilityCard(
    $,
    createSimplePrivateGallery, // eslint-disable-line no-shadow
    options,
    openUnitCard, // eslint-disable-line no-shadow
    closeOtherCardsInFacility, // eslint-disable-line no-shadow
    triggerGoogleAnalyticsSendEvent, // eslint-disable-line no-shadow
) {
    const { facility } = options;
    const facilityId = JSON.parse(facility.getAttribute('data-facility-id'));
    const unitIds = JSON.parse(facility.getAttribute('data-unit-ids'));
    const facilityGallery = setUpGallery();
    commentShowUnconfigured();
    initDoubleFacilityScroll();
    initUnitCards();
    setUpGoogleAnalytics();

    function initDoubleFacilityScroll() {
        $(facility).on('click', '.sharedFacility', function scrollToDoubleFacility(e) {
            e.preventDefault();
            const scrollToFacilityId = $(this).data('facility-id');
            const scrollToElement = document.querySelector(`li[data-facility-id="${scrollToFacilityId}"]`);
            scrollToElement.classList.remove('shared');
            scrollFacilityToMiddle(scrollToElement);
        });
    }

    function scrollFacilityToMiddle(scrollToElement) {
        const elementPositon = $(scrollToElement).offset().top;
        const windowHeight = window.screen.height;
        const halfOfElement = scrollToElement.offsetHeight / 2;
        const scrollTo = elementPositon - windowHeight / 2 + halfOfElement;

        $('html, body').animate({ scrollTop: scrollTo }, 300, 'swing', () => {
            scrollToElement.classList.add('shared');
        });
    }

    function setUpGallery() {
        const galleryContainer = facility.querySelector('.searchPrivateFacilityGallery');

        const gallery = createSimplePrivateGallery({
            source: $('#galleryData').data('url-facility'),
            nextButton: galleryContainer.querySelector('.simpleGalleryNext'),
            previousButton: galleryContainer.querySelector('.simpleGalleryPrev'),
            counterElement: galleryContainer.querySelector('.simpleGalleryCounter'),
            imageElement: galleryContainer.querySelector('.currentImage img'),
            imageDescription: galleryContainer.querySelector('figcaption'),
            queryParameters: { facilityid: facilityId, unitids: unitIds },
            galleryHeight: galleryContainer.style.height,
        });

        // ako slika pripada jedinici otvara karticu te jedinice, u suprotnom prvu karticu
        gallery.onGalleryClick((imageData) => {
            const unitId = imageData.unitId ? imageData.unitId : unitIds[0];
            const unitToOpen = facility.querySelector(`.unitInfo[data-unit-id="${unitId}"]`);

            openUnitCard({ unitToggler: unitToOpen, openTriggered: true })();

            closeOtherCardsInFacility({ facility, unitId })();
        });

        return gallery;
    }

    function setUpGoogleAnalytics() {
        const showOnMapButton = facility.querySelector('.showOnMap');

        if (showOnMapButton) {
            showOnMapButton.addEventListener('click', () => {
                triggerGoogleAnalyticsSendEvent('Rezultati pretrage', 'Vidi na karti', 'klik');
                scrollToTopPosition();
            });
        }

        facilityGallery.onGalleryClick((imageData) => {
            const category = imageData.category ? imageData.category : 'cover-image';
            triggerGoogleAnalyticsSendEvent('Rezultati pretrage', 'Objekt slika', category);
        });

        facilityGallery.afterNewImageDisplay((imageData) => {
            triggerGoogleAnalyticsSendEvent(
                'Rezultati pretrage',
                'Galerija',
                `listanje-${imageData.currentIndex}/${imageData.totalImages}`,
            );
        });
    }

    function scrollToTopPosition() {
        const windowScrollTop = window.scrollY;
        const windowScrollTopIe = window.pageYOffset;

        if (windowScrollTop || windowScrollTopIe < 200) {
            verticalSmoothScrollToPosition($('html, body'), 200, 0);
        }
    }

    function commentShowUnconfigured() {
        const comment = facility.querySelector('.facilitySummary p');

        if (comment) {
            const showMoreElement = document.createElement('span');
            showMoreElement.classList.add('showMore');

            if (comment.offsetHeight > 65) {
                comment.classList.add('closed');
                comment.style.maxHeight = 65;
                comment.appendChild(showMoreElement);
            }
        }

        const commentContainer = facility.querySelector('.facilitySummary .closed, .facilitySummary .open');

        if (commentContainer) {
            commentContainer.addEventListener('click', function toggleComment() {
                $(this).toggleClass('open', slideToggleTime);
                $(this).toggleClass('closed', slideToggleTime);
            });
        }
    }

    function initUnitCards() {
        $(facility).on('click', '.unitInfo', function toggleUnitCard(e) {
            e.preventDefault();

            openUnitCard({
                unitToggler: this,
                openPricelist: Boolean(this.querySelector('.unitCheckPrice')),
            })();
        });
    }

    return { gallery: facilityGallery };
}

function cardAnimation() {
    $('#searchResults>li').css('visibility', 'hidden');
    $('#searchResults>li').each((index, facilityCard) => {
        setTimeout(() => { $(facilityCard).css('visibility', '').addClass('slideUpAnimation'); }, 100 * index);
    });
}

const facilityCardSlideAnimation = () => cardAnimation.bind(null, $, document);
const facilityCard = (options) => unconfiguredFacilityCard.bind(
    null,
    $,
    createSimplePrivateGallery,
    options,
    openUnitCard,
    closeOtherCardsInFacility,
    triggerGoogleAnalyticsSendEvent,
);

export {
    facilityCard,
    facilityCardSlideAnimation,
    unconfiguredFacilityCard as facilityCardTestExport,
};
